import { toast } from "react-hot-toast";
import { useLocation } from "wouter";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGitContext } from "./ModelContext.tsx";

export function DeleteGitDialog() {
  const git = useGitContext();
  const [_, navigate] = useLocation();

  return (
    <ConfirmDialog
      heading="Delete git?"
      description={`Are you sure you want to delete ${git.name}? You cannot undo this.`}
      submitLabel="Delete"
      theme="red"
      onSubmit={() => {
        const nextGang = git.gang.removeGit(git);
        return database.gangs.updateOne(nextGang.data);
      }}
      onSuccess={(gangId) => {
        toast("Git deleted");
        navigate(`~/gangs/g/${gangId}`);
      }}
    />
  );
}
